import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/franceFlag.png'
import _imports_1 from '../assets/ionic-ios-arrow-back.svg'


const _withScopeId = n => (_pushScopeId("data-v-be89a6b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sources" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dark-blue" }, "Sources", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Recommandations françaises "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "toggle-info bg-gray" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Autres sources")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right",
  src: _imports_1
}, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  class: "toggled",
  id: 'usa-ref'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefCard = _resolveComponent("RefCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SourcesFR, (source, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createVNode(_component_RefCard, {
          type: source.type,
          source: source.source,
          year: source.year,
          content: source.content,
          url: source.url
        }, null, 8, ["type", "source", "year", "content", "url"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h4", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleContent('usa-ref')))
      }, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SourcesUSA, (source, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createVNode(_component_RefCard, {
              type: source.type,
              source: source.source,
              year: source.year,
              content: source.content,
              url: source.url
            }, null, 8, ["type", "source", "year", "content", "url"])
          ]))
        }), 128))
      ])
    ])
  ]))
}